import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import { Line } from '../../utils/globalPropTypes';
import useToast from '../../hooks/useToast';
import LoaderContext from '../../context/LoaderProvider';
import { deleteLine, deletePositionLineOrUbication } from '../../services/workReport';

const DeleteLineModal = (props) => {
  const { line, showDeleteModal, setShowDeleteModal, setNewFetch, isMonthly } = props;

  const { setNewToast } = useToast();

  const { setLoader } = useContext(LoaderContext);

  // Delete if is Monthly (MSDS)

  const deleteLineWorkReportMonthly = async () => {
    setLoader(true);
    try {
      const res = await deletePositionLineOrUbication(line.idUbicacionLinea);

      setLoader(false);
      setNewFetch((oldValue) => !oldValue);
      setNewToast({
        type: 'SUCCESS',
        message: res.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const deleteLineWorkReport = async () => {
    setLoader(true);
    try {
      const res = await deleteLine(line.idParteDiario);

      setLoader(false);
      setNewFetch((oldValue) => !oldValue);
      setNewToast({
        type: 'SUCCESS',
        message: res.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => setShowDeleteModal(false)}
      primaryAction={() => {
        if (isMonthly) {
          deleteLineWorkReportMonthly();
        } else {
          deleteLineWorkReport();
        }
        setShowDeleteModal(false);
      }}
      primaryActionLabel="Aceptar"
      secondaryAction={() => setShowDeleteModal(false)}
      secondaryActionLabel="Salir"
      show={showDeleteModal}
      size="md"
      title="Eliminar"
      variantHeader="danger"
    >
      <div className="modal_body_error">
        {!line.ubicacionStr ? (
          <>
            ¿Querés eliminar la <strong>{`"Línea ${line.numeroLinea}`}</strong>{' '}
            {`- ${line.descripcionLineaSap}`} <strong> {`Posición ${line.numeroPosicion}`}</strong>{' '}
            {`- ${line.descripcionPosicionSap}"?`}
          </>
        ) : (
          <>
            ¿Querés eliminar la <strong>{`ubicación ${line.ubicacionStr}`}</strong>?
          </>
        )}
      </div>
    </ModalGeneric>
  );
};

DeleteLineModal.propTypes = {
  line: Line.isRequired,
  showDeleteModal: PropTypes.bool.isRequired,
  isMonthly: PropTypes.bool,
  setShowDeleteModal: PropTypes.func.isRequired,
  setNewFetch: PropTypes.func.isRequired
};

DeleteLineModal.defaultProps = {
  isMonthly: false
};

export default DeleteLineModal;
